import {ReactNode} from "react";

interface IProps {
    children: ReactNode;
}

const FormWrapper = ({children}: IProps) => {
    return (
        <section
            className={"self-center my-5 md:py-20 px-6 md:px-16 max-w-lg bg-neutral-900 rounded-3xl w-full py-16 shadow-neutral-900 shadow-3xl"}>
            {children}
        </section>
    );
};

export default FormWrapper;